import { render, staticRenderFns } from "./modalAgendarCita.vue?vue&type=template&id=bbca8e2a"
import script from "./modalAgendarCita.vue?vue&type=script&lang=js"
export * from "./modalAgendarCita.vue?vue&type=script&lang=js"
import style0 from "./modalAgendarCita.vue?vue&type=style&index=0&id=bbca8e2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports